import {Hub} from '@aws-amplify/core';


import {getSentry} from "../utils/errors/getSentry";
import {ServiceRegistry} from "../platform/ServiceRegistry";
import {saveAttributionAfterOAuth} from "./authAttribution";


export const initAuthListener = () => {
    return Hub.listen('auth', async hubData => {
        const {event} = hubData.payload;
        switch (event) {
            case "signInWithRedirect_failure":
                // handle sign in failure
                break;
            case "customOAuthState":
                const state = hubData.payload.data; // this will be customState provided on signInWithRedirect function
                console.log(state);
                break;
            case "signInWithRedirect":
            case "signedIn":
            case "tokenRefresh":
                // On successful sign-in or token refresh, proactively refresh pgServer WS client
                try {
                    // NOTE: Using getInstance here is acceptable because this is a global event listener
                    // that runs outside React context. The registry should be initialized before auth events fire.
                    const registry = ServiceRegistry.getInstance();
                    if (!registry) {
                        console.warn('ServiceRegistry not initialized yet, skipping WS reconnect on token refresh');
                        break;
                    }
                    const dataClients = registry.getDataClientService();
                    const ws = await dataClients.getWsClientByKey('pgServer');
                    if (ws) {
                        console.log('[Auth] Token refreshed, reconnecting pgServer WebSocket with new token');
                        await ws.retryConnection();
                    }
                } catch (e) {
                    // ServiceRegistry might not be initialized yet; ignore
                    console.warn('[Auth] Failed to reconnect pgServer WS on token refresh:', e);
                }
                // After Google OAuth redirect, save UTM attribution once (idempotent on server)
                if (event === 'signInWithRedirect') {
                    saveAttributionAfterOAuth();
                }
                break;
            case "tokenRefresh_failure":
                // If refresh failed, subscriptions will break; allow server to close sockets, but we can proactively drop clients if needed
                try {
                    const registry = ServiceRegistry.getInstance();
                    if (!registry) {
                        break;
                    }
                    const dataClients = registry.getDataClientService();
                    const ws = await dataClients.getWsClientByKey('pgServer');
                    if (ws) {
                        console.warn('[Auth] Token refresh failed, attempting WS reconnect');
                        await ws.retryConnection();
                    }
                } catch (e) {
                    console.warn('[Auth] Failed to reconnect pgServer WS on token refresh failure:', e);
                }
                break;
            case "signedOut":
                getSentry().then(sentryAsync => {
                    sentryAsync.setSentryUser(null);
                });
                break;
        }
    }) as () => void;
}
